import axios from "axios";

const consumerProductsURL="/api/consumeraccount/consumerproducts";
const consumerFundingsURL = '/api/consumeraccount/consumerfunding';
const consumerAddToBasketURL = '/api/consumeraccount/add-consumer-products-to-basket';

const accountPage = {
	state: () => ({
		menuLinks: [],
		fundingsData: {},
		contactsData: {},
		productsData: {},
		language: '',
		heyloPrescriptionData: {},
		heyloContactsData: {},
		heyloStomaData: {},
		showContactSkeleton: true,
		showProductsSkeleton: true,
		showRecommendationNotification: false,
		recommendationLink: '',
		recommendationSubstitution: ''
	}),
	getters: {
		getFundingsData: function (state) {
			return state.fundingsData;
		},
		getContactsData: function (state) {
			return state.contactsData;
		},
		getMenuLinks: function (state) {
			return state.menuLinks;
		},
		getProductsData: function (state) {
			return state.productsData;
		},
		getHeyloPrescriptionData: function (state) {
			return state.heyloPrescriptionData;
		},
		getHeyloContactsData: function (state) {
			return state.heyloContactsData;
		},
		getHeyloStomaData: function (state) {
			return state.heyloStomaData;
		},
		getShowContactSkeleton: (state) => {
			return state.showContactSkeleton;
		},
		getShowProductsSkeleton: (state) => {
			return state.showProductsSkeleton;
		},
		getShowRecommendationNotification: (state) => {
			return state.showRecommendationNotification;
		},
		getRecommendationNotification: (state) => {
			return state
				.recommendationLink
				.split('{recommendation}')
				.join(`<a href="#recommendation-block">${ state.recommendationSubstitution }</a>`);
		},
	},
	mutations: {
		setFundingsData: function (state, data) {
			state.fundingsData = data;
		},
		setContactsData: function (state, data) {
			state.contactsData = data;
		},
		setMenuLinks: function (state, payload) {
			state.menuLinks.push({ ...payload, isActive: false});
		},
		setProductsData: function (state, data) {
			state.productsData = data;
		},
		setLanguage: (state, language) => {
			state.language = language;
		},
		setHeyloPrescriptionData: (state, data) => {
			state.heyloPrescriptionData = data;
		},
		setHeyloContactsData: (state, data) => {
			state.heyloContactsData = data;
		},
		setHeyloStomaData: (state, data) => {
			state.heyloStomaData = data;
		},
		hideContactSkeleton: (state) => {
			state.showContactSkeleton = false;
		},
		hideProductsSkeleton: (state) => {
			state.showProductsSkeleton = false;
		},
		showRecommendationNotification: (state) => {
			state.showRecommendationNotification = true;
		},
		hideRecommendationNotification: (state) => {
			state.showRecommendationNotification = false;
		},
		setRecommendationLink: (state, data) => {
			state.recommendationLink = data;
		},
		setRecommendationSubstitution: (state, data) => {
			state.recommendationSubstitution = data;
		},
	},
	actions: {
		getFundings: ( {commit, state}) => {
			if (!state.showContactSkeleton) {
				commit('setSpinnerIsShown', true, { root: true });
			}
			axios.get(consumerFundingsURL)
				.then(response => {
					commit('setFundingsData', response.data.fundings[0]);
					commit('setSpinnerIsShown', false, { root: true })
				})
				.catch(error => {
					commit('setFundingsData', error.response);
					commit('setSpinnerIsShown', false, { root: true })
				});
		},
		getContacts: ( {commit, state}, url) => {
			if (!state.showContactSkeleton) {
				commit('setSpinnerIsShown', true, { root: true });
			}
			axios.get(url)
				.then(response => {
					commit('setContactsData', response.data);
					commit('setSpinnerIsShown', false, { root: true });
					commit('hideContactSkeleton');
				})
				.catch(error => {
					commit('setContactsData', error.response);
					commit('setSpinnerIsShown', false, { root: true });
					commit('hideContactSkeleton');
				})
		},
		getProducts: ( {commit, state}) => {
			if (!state.showContactSkeleton) {
				commit('setSpinnerIsShown', true, { root: true });
			}
			axios.get(`${ consumerProductsURL }?language=${ state.language }`)
				.then(response => {
					commit('setProductsData', response.data);
					commit('setSpinnerIsShown', false, { root: true })
					commit('hideProductsSkeleton');
				})
				.catch(error => {
					commit('setProductsData', error.response);
					commit('setSpinnerIsShown', false, { root: true })
					commit('hideProductsSkeleton');
				});
		},
		addMenuLinks: ( {commit}, payload ) => {
			commit('setMenuLinks', payload)
		},
		activateMenuLinks: ( {state}, linkToUpdate ) => {
			state.menuLinks.map((item) => {
				item.isActive = item.label === linkToUpdate.label;
			});
		},
		removeMenuLinks: ( {state}, linkToUpdate ) => {
			state.menuLinks = state.menuLinks.filter((obj) => {
				return obj.label !== linkToUpdate;
			});
		},
		getHeyloPrescription: ({commit}, url) => {
			commit('setSpinnerIsShown', true, { root: true })
			axios.get(url)
				.then(response => {
					commit('setHeyloPrescriptionData', response.data);
					commit('setSpinnerIsShown', false, { root: true })
				})
				.catch(error => {
					commit('setHeyloPrescriptionData', error.response);
					commit('setSpinnerIsShown', false, { root: true })
				})
		},
		getHeyloContacts: ({commit}, url) => {
			commit('setSpinnerIsShown', true, { root: true })
			axios.get(url)
				.then(response => {
					commit('setHeyloContactsData', response.data);
				})
				.catch(error => {
					commit('setHeyloContactsData', error.response);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true })
				})
		},
		getHeyloStoma: ({commit}, url) => {
			commit('setSpinnerIsShown', true, { root: true })
			axios.get(url)
				.then(response => {
					commit('setHeyloStomaData', response.data);
				})
				.catch(error => {
					commit('setHeyloStomaData', error.response);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true })
				})
		},
	}
};

export default accountPage;
